import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, SimpleModal } from '@livable/saas-react-components';
// import { Tab, Tabs } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropFileUploader from 'src/components/shared/DropFileUploader';
import { useStore } from 'src/stores';
import ActionsCell from './ActionsCell';
import useStyles from './styles';
const AttachBillFileModal = observer(props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const disabled = props.disabled,
    dropFileUploaderCallback = props.dropFileUploaderCallback,
    property = props.property,
    setIsFileLoading = props.setIsFileLoading,
    utilityId = props.utilityId;
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const isOpen = currentCompany.billingTab.isAttachBillFileModalOpen;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    bills = _useState2[0],
    setBills = _useState2[1];
  // const [selectedTab, setSelectedTab] = useState('previous');
  const selectedTab = 'previous';
  const getFilesInfo = async data => {
    const resp = await store.files.getFilesInfoAsync.run(data);
    return resp;
  };
  const getPropertyBillsFileCabinet = async data => {
    const resp = await store.allocations.getPropertyBillsFileCabinetAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (property.id) getPropertyBillsFileCabinet({
      propertyId: property.id
    }).then(response => {
      var _response$response;
      const billsData = (response === null || response === void 0 || (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.filter(bill => bill.fileId && bill.utilityId === utilityId)) || [];
      setBills(billsData);
      const fileIds = billsData.map(bill => bill.fileId).filter(Boolean);
      if ((fileIds === null || fileIds === void 0 ? void 0 : fileIds.length) > 0) return getFilesInfo({
        fileIds
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property.id]);
  const handleClose = () => currentCompany.billingTab.setIsAttachBillFileModalOpen('');
  // const handleTabChange = (e, newValue) => setSelectedTab(newValue);

  const renderCell = (parameter, left, longName) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft, " ").concat(longName && classes.cellLongName)
  }, longName ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: 'top',
    title: parameter,
    type: 'success-bold-dark'
  }, parameter) : parameter);
  const renderHeader = (text, right) => /*#__PURE__*/React.createElement("span", {
    className: right && classes.rightAlign
  }, text);
  const columns = [{
    align: 'right',
    field: 'fileName',
    flex: 1,
    minWidth: 300,
    renderCell: params => {
      var _store$files$fileData;
      return renderCell(params.row.fileId ? (_store$files$fileData = store.files.fileDataById.get(params.row.fileId)) === null || _store$files$fileData === void 0 ? void 0 : _store$files$fileData.fileName : 'N/A', true, true);
    },
    renderHeader: () => renderHeader('File \nName')
  }, {
    align: 'right',
    flex: 1,
    field: 'allocationName',
    maxWidth: 130,
    minWidth: 120,
    hideable: false,
    renderCell: params => renderCell(params.row.allocationName, true),
    renderHeader: () => renderHeader('Cycle'),
    sortComparator: (v1, v2) => {
      var _ref;
      return (_ref = '' + v1) === null || _ref === void 0 ? void 0 : _ref.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'right',
    flex: 1,
    field: 'actionsCell',
    maxWidth: 120,
    minWidth: 85,
    hideable: false,
    headerAlign: 'right',
    renderHeader: () => renderHeader('Actions'),
    renderCell: params => /*#__PURE__*/React.createElement(ActionsCell, {
      handleModalClose: handleClose,
      params: params,
      property: property
    })
  }];
  const callback = async id => {
    dropFileUploaderCallback(id);
    handleClose();
    currentCompany.billingTab.setIsFileChosen(true);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    noPadding: true,
    isOpen: isOpen,
    title: t('allocations.use_previous_bills'),
    subTitle: isOpen,
    className: classes.modal,
    variant: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, selectedTab === 'upload' ? /*#__PURE__*/React.createElement(DropFileUploader, {
    callback: callback,
    disabled: disabled,
    openBillModal: false,
    isFileUploadingAccepted: store.files.isFileUploadingAccepted,
    isOnlyUploader: true,
    label: t('allocations.attach_bill_file'),
    tooltipText: "".concat(t('allocations.livable_transparency'), " ").concat(t('allocations.you_share_bill')),
    uploadStartedCallback: () => setIsFileLoading(true)
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.previousBills
  }, /*#__PURE__*/React.createElement(DataGrid, {
    columns: columns,
    disableColumnMenu: true,
    disableRowSelectionOnClick: true,
    getRowId: row => row.fileId,
    pagination: true,
    pageSize: 10,
    rowsPerPageOptions: [5, 10, 20],
    autoHeight: false,
    columnHeaderHeight: 80,
    rowHeight: 60,
    sx: {
      overflowX: 'scroll'
    },
    hideFooterSelectedRowCount: true,
    getRowClassName: () => classes.row,
    initialState: {
      pagination: {
        paginationModel: {
          pageSize: 25,
          page: 0
        }
      }
    },
    rows: bills
  }))));
});
export default AttachBillFileModal;